import { render, staticRenderFns } from "./my-footer-new.vue?vue&type=template&id=d8a51abe&scoped=true"
import script from "./my-footer-new.vue?vue&type=script&lang=js"
export * from "./my-footer-new.vue?vue&type=script&lang=js"
import style0 from "./my-footer-new.vue?vue&type=style&index=0&id=d8a51abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a51abe",
  null
  
)

export default component.exports